import Header from './Header'

import Nelson from './Nelson'
import { useState, useEffect } from 'react'
import './Soon.css'

const Soon = ({ onScreenUpdate }) => {
  const sound = 'snort'
  const [dialogue, setDialogue] = useState(null)
  const [showDialogue, setShowDialogue] = useState(false)
  const [learnLink, setLearnLink] = useState(null)
  const [dialogueLinkText, setDialogueLinkText] = useState('Join the Club')

  const [hovering, setHovering] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (hovering) {
      const audio = document.getElementById(sound)
      audio.play().catch((e) => {
        console.log(e)
      })
    }
  }, [hovering, sound])

  const doHover = (hovering) => {
    setHovering(hovering)
  }

  return (
    <div className="mainContainer">
      <audio id="snort" src="audio/fx/neighSnort.mp3" />

      <Header onScreenUpdate={onScreenUpdate} />
      <img
        className="EHPImage"
        sound={'snort'}
        src="images/game/EHPImage.png"
        onMouseEnter={() => doHover(true)}
        onMouseLeave={() => doHover(false)}
        alt="Screenshot from Exercising Horsepower game."
        onClick={(speaking) => {
          setShowDialogue(speaking)
          setDialogue(
            <div>
              <p>
                Want to be the first to know about new games and updates to
                Equine Science 4 Kids?
              </p>
              <p>
                Join my fan club and get messages straight from the horse's
                mouth.
              </p>
            </div>
          )
          setLearnLink('/pages/main/joinFanClub.html')
          setDialogueLinkText('Join the Club')
        }}
      />
      <Nelson
        showDialogue={showDialogue}
        dialogue={dialogue}
        setShowDialogue={setShowDialogue}
        learnLink={learnLink}
        dialogueLinkText={dialogueLinkText}
        setDialogueLinkText={setDialogueLinkText}
      />
    </div>
  )
}

export default Soon
